import { Button } from "@/components/ui/button";
import { FileDown } from "lucide-react";
import { API, withCompany } from "@/lib/api";

export default function ExcelButton({ params = {}, testid = "excel-download-button" }) {
  const download = () => {
    const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v)).toString();
    window.location.href = withCompany(`${API}/reports/hakedis.xlsx${qs ? `?${qs}` : ""}`);
  };
  return (
    <Button variant="outline" onClick={download} data-testid={testid} className="border-emerald-600/40 text-emerald-700 dark:text-emerald-400 hover:bg-emerald-500/10">
      <FileDown className="w-4 h-4 mr-1" /> Excel İndir
    </Button>
  );
}
